import { Loading, Page } from "components";
import { useContext } from "react";
import { Filters, Results, Toolbar } from "./components";
import { adminUsersContext } from "./AdminUsersContext";


let Users = () => {
    let service = useContext(adminUsersContext);

    return (
        <Page title="Admin Users">
            <div className="container-fluid special-p" style={{ marginTop: 18, marginBottom: 18 }}>
                {service.isLoading && <Loading />}
                {service.isLoading === false &&
                    <>
                        <Filters />
                        <Toolbar />
                        <Results />
                    </>
                }
            </div>
        </Page>
    )
}

export default Users;